import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TextInputComponent } from 'ddmo-storybook-lib';
import { SharedService } from '../../../../../shared/services/shared.service';
import { LABELS } from '../../../../../shared/constants/lables.constants';
import { LoaderService } from '../../../../../shared/services/loader.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatRadioButton } from '@angular/material/radio';
import { MatDialog } from '@angular/material/dialog';
import { W9AlertComponent } from '../../../../popups/processing/processing.component';

@Component({
  selector: 'app-search-tin',
  imports: [TextInputComponent, FormsModule, CommonModule, MatPaginator, MatRadioButton],
  templateUrl: './search-tin.component.html',
  styleUrl: './search-tin.component.scss'
})
export class SearchTinComponent implements OnInit {
  private readonly SEARCH_TIN_DISTINCT_PAYEES_KEY = 'SearchTINDistinctPayees';
  private readonly SEARCH_TIN_DISTINCT_PAYEES_TIN_KEY = 'SearchTINDistinctPayeesTin';
  private readonly SEARCH_TIN_TAX_ENTITY_KEY = 'SearchTINTaxEntityDetails';
  private readonly SEARCH_TIN_TAX_ENTITY_TIN_KEY = 'SearchTINTaxEntityTin';
  selectedLocationId: number | null = null;
  locations: any = []
  displayedLocations: any[] = [];
  searchDone = false
  TinError = false
  pageSize = 5;
  pageIndex = 0;
  totalRecords = 0;
  allTINs: any[] = [];
  searchedTIN : any;
  tinErrorMessage = "TIN doesn't exists, please proceed to add your TIN"
  public tinForm = new FormGroup(({
    TIN: new FormControl('', [Validators.minLength(9), Validators.maxLength(9)]),

  }))
  errormessages = LABELS.ERROR_MESSAGES
  constructor(private router: Router, private sharedService: SharedService, private loader: LoaderService, public dialog: MatDialog) { }

  private getStorageArray(key: string): any[] {
    const parsed = JSON.parse(localStorage.getItem(key) || '[]');
    if (Array.isArray(parsed)) return parsed;
    return parsed ? [parsed] : [];
  }

  onBack() {
    this.router.navigate(['/credentialing/locations']);
  }
  ngOnInit(): void {
    this.loader.show()
    this.allTINs = this.getStorageArray('TINDetails');
    if (this.allTINs && this.allTINs.length > 0) {
      const searchedTIN = localStorage.getItem("SearchedTin")
      this.searchedTIN = searchedTIN;
      const isPresent = this.allTINs.find((x: any) => x.taxId == searchedTIN)
      if (isPresent) {
        this.tinErrorMessage = "TIN is already in this session. please proceed to add your location"
      } else {
        this.tinErrorMessage = "TIN doesn't exists, please proceed to add your TIN"
      }
    }
    if (localStorage.getItem("SearchedTin")) {
      this.tinForm.setValue({
        'TIN': localStorage.getItem("SearchedTin")
      })
      if (localStorage.getItem("SearchTINResponse")) {
        this.locations = this.getStorageArray("SearchTINResponse");
        this.totalRecords = this.locations.length;
        this.displayedLocations = this.locations.slice(0, this.pageSize);
        this.searchDone = true
        if (!this.locations.length && localStorage.getItem("SearchTinHasEntity") === "true") {
          this.tinErrorMessage = "No locations found for this TIN.";
          this.TinError = true;
        }
      } else {
        this.locations = []
        this.totalRecords = this.locations.length;
        this.displayedLocations = this.locations.slice(0, this.pageSize);
        if (localStorage.getItem("SearchedTin") && localStorage.getItem("SearchedTin")?.length == 9) {
          this.searchDone = true
        }
      }
      this.loader.hide()
    }
    this.loader.hide()

  }
  errormsg(fieldName: any) {
    if (fieldName == "TIN") {
      return {
        ...this.errormessages,
        minlength: `${fieldName} should be 9 digits`,
      };
    }
    return {
      ...this.errormessages,
      minlength: `${fieldName} doesn't meet requirements`
    };
  }
  searchTIN() {
    this.tinErrorMessage = ""
    const tin = this.tinForm.get('TIN')?.value?.trim();
    this.TinError = false;
    sessionStorage.removeItem("selectedLocationRecord");
    sessionStorage.removeItem("isNewLocationTIN");
    localStorage.removeItem("editLocationId");
    localStorage.removeItem("isnewTIN");
    localStorage.removeItem("isTINEditMode");
    localStorage.removeItem("isEditMode");
    localStorage.removeItem("isW9Alert");
    localStorage.removeItem("editTinData");
    localStorage.removeItem("locationValueFromTINSave");
    localStorage.removeItem("TINValueFromTINSave");
    localStorage.removeItem("SearchTINResponse")
    localStorage.removeItem("SearchTinHasEntity")
    localStorage.removeItem(this.SEARCH_TIN_DISTINCT_PAYEES_KEY)
    localStorage.removeItem(this.SEARCH_TIN_DISTINCT_PAYEES_TIN_KEY)
    localStorage.removeItem(this.SEARCH_TIN_TAX_ENTITY_KEY)
    localStorage.removeItem(this.SEARCH_TIN_TAX_ENTITY_TIN_KEY)
    if (tin && tin.length === 9) {
      localStorage.setItem('SearchedTin', tin);
      this.searchedTIN = tin;
      this.loader.show();
      this.tinForm.get('TIN')?.disable()
      localStorage.setItem('SearchedTin', tin);
      const loggedUserDetails = JSON.parse(localStorage.getItem("loggedUserDetails") || '{}')
      let providerState = loggedUserDetails?.licenseState;
      const userDetails: any = JSON.parse(localStorage.getItem("loggedUserDetails")!);
      const payload = {
        taxId: tin,
        pageSize: 200,
        pageNumber: 1
      };

      this.sharedService.searchTIN(payload).subscribe({
        next: (res: any) => {
          try {
            const filteredApiLocations = this.buildLocationsFromResponse(res, tin, userDetails?.licenseState);
            const existingPayees = this.getDistinctPayeesFromResponse(res);
            const taxEntityDetails = this.getTaxEntityDetailsFromResponse(res, tin);
            localStorage.setItem(this.SEARCH_TIN_DISTINCT_PAYEES_KEY, JSON.stringify(existingPayees))
            localStorage.setItem(this.SEARCH_TIN_DISTINCT_PAYEES_TIN_KEY, tin)
            if (Object.keys(taxEntityDetails).length > 0) {
              localStorage.setItem(this.SEARCH_TIN_TAX_ENTITY_KEY, JSON.stringify(taxEntityDetails));
              localStorage.setItem(this.SEARCH_TIN_TAX_ENTITY_TIN_KEY, tin);
            }
            const filteredRecords = this.mergeLocations(
              filteredApiLocations,
              this.getSessionLocationsByTin(tin)
            ).map((location: any) => ({ ...location, existingPayees }));
            localStorage.setItem('SearchTINResponse', JSON.stringify(filteredRecords))
            this.locations = filteredRecords
            this.totalRecords = this.locations.length;
            this.displayedLocations = this.locations.slice(0, this.pageSize);
            this.searchDone = true;
            if (!filteredRecords?.length) {
              // API contract: success (200) with no state-matching records means
              // TIN exists in DW, but no locations for this license state.
              localStorage.setItem('SearchTinHasEntity', 'true');
              this.tinErrorMessage = "No locations found for this TIN.";
              this.TinError = true;
            }
          } catch (e) {
            localStorage.removeItem(this.SEARCH_TIN_DISTINCT_PAYEES_KEY)
            localStorage.removeItem(this.SEARCH_TIN_DISTINCT_PAYEES_TIN_KEY)
            localStorage.removeItem(this.SEARCH_TIN_TAX_ENTITY_KEY)
            localStorage.removeItem(this.SEARCH_TIN_TAX_ENTITY_TIN_KEY)
            this.searchDone = true;
            this.locations = [];
            this.totalRecords = 0;
            this.displayedLocations = [];
            this.tinErrorMessage = "TIN doesn't exists, please proceed to add your TIN";
            this.TinError = true;
          } finally {
            this.tinForm.get('TIN')?.enable()
            this.loader.hide();
          }
        },
        error: (err) => {
          localStorage.removeItem(this.SEARCH_TIN_DISTINCT_PAYEES_KEY)
          localStorage.removeItem(this.SEARCH_TIN_DISTINCT_PAYEES_TIN_KEY)
          localStorage.removeItem(this.SEARCH_TIN_TAX_ENTITY_KEY)
          localStorage.removeItem(this.SEARCH_TIN_TAX_ENTITY_TIN_KEY)
          this.loader.hide()
          this.tinForm.get('TIN')?.enable()
          this.searchDone = true;
          localStorage.setItem('SearchTinHasEntity', 'false');
          this.locations = this.getSessionLocationsByTin(tin);
          const isTinAlreadyInSession = this.locations.length > 0 || this.allTINs.some(
            (item: any) => item?.taxId == tin || item?.tin == tin
          );
          this.tinErrorMessage = isTinAlreadyInSession
            ? "TIN is already in this session. please proceed to add your location"
            : "TIN doesn't exists, please proceed to add your TIN";
          this.totalRecords = this.locations.length;
          this.displayedLocations = this.locations.slice(0, this.pageSize);
          this.TinError = true;
        },
        complete: () => {
          this.loader.hide();
        }
      });
    } else {
      this.searchDone = false;
      this.locations = [];
      // Show error only after user enters something
      if (tin && tin.length > 0) {
        this.TinError = true;
      }
    }
  }

  restrictNonNumeric(event: KeyboardEvent): void {
    this.sharedService.preventNonNumeric(event);
  }

  onProceed(): void {
    const selectedRecord = this.locations.find(
      (x: any) => x.locationId === this.selectedLocationId
    );
    const locations = this.getStorageArray("locations");
    const isLocationAlreadyExists = locations?.length > 0 ? locations?.every((loc: any) => loc.esLocationId == selectedRecord.locationId): false;
    if (isLocationAlreadyExists) {
      this.W9AlertPopupCall(true)
    } else {
      sessionStorage.removeItem("isNewLocationTIN");
      localStorage.removeItem("isnewTIN");
      localStorage.removeItem("editLocationId");
      localStorage.removeItem("isTINEditMode");
      localStorage.removeItem("isEditMode");
      selectedRecord['esLocationId'] = selectedRecord.locationId;
      localStorage.setItem('editTinData', JSON.stringify(selectedRecord));
      sessionStorage.setItem("selectedLocationRecord", JSON.stringify(selectedRecord))
      this.router.navigate(['/credentialing/locations/add']);
    }
  }

  GoToNewLocationPage() {
    sessionStorage.removeItem("selectedLocationRecord")
    localStorage.removeItem("isnewTIN");
    localStorage.removeItem("editLocationId");
    localStorage.removeItem("isTINEditMode");
    localStorage.removeItem("isEditMode");
    localStorage.removeItem("isW9Alert");
    localStorage.removeItem("editTinData");
    localStorage.removeItem("locationValueFromTINSave");
    localStorage.removeItem("TINValueFromTINSave");
    const tin = this.tinForm.get('TIN')?.value || '';
    sessionStorage.setItem("isNewLocationTIN", tin)
     this.router.navigate(['/credentialing/locations/add']);
  }

  onAddTin() {
    sessionStorage.removeItem("selectedLocationRecord");
    sessionStorage.removeItem("isNewLocationTIN");
    localStorage.removeItem("editLocationId");
    localStorage.removeItem("isTINEditMode");
    localStorage.removeItem("isEditMode");
    localStorage.removeItem("isW9Alert");
    localStorage.removeItem("editTinData");
    if (this.tinErrorMessage == "TIN doesn't exists, please proceed to add your TIN") {
      localStorage.setItem("isnewTIN", "true")
    }
    localStorage.removeItem('LocationSavePayload')
    this.router.navigate(['/credentialing/locations/add']);
  }

  onPageChange(event: any): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;

    const start = this.pageIndex * this.pageSize;
    const end = start + this.pageSize;

    this.displayedLocations = this.locations.slice(start, end);
  }

  W9AlertPopupCall(isLocationExist?: any) {
    this.loader.hide();
    let alertMessage: any
    if (isLocationExist) {
      alertMessage = "This location is already added, please select another location or add new location"
    } else {
      alertMessage = "Please upload W9 for the TIN to proceed by clicking below";
    }
    let dialogRef = this.dialog.open(W9AlertComponent, {
      disableClose: true,
      data: { message: alertMessage },
      width: '550px',
      backdropClass: '',
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result == true && !isLocationExist) {
        localStorage.setItem("isW9Alert", "true")
        this.router.navigate(['/credentialing/locations/add-tin'])
      }
    });
  }

  isW9needed() {
    const payload = {
      "taxId": localStorage.getItem("SearchedTin"),
      "userId": localStorage.getItem('user_id'),
      "credentialingEventId": localStorage.getItem('credentialingEventId')
    }
    this.sharedService.getW9UploadStatus(payload).subscribe({
      next: (res: any) => {
        if (res && !res.hasW9Uploaded) {
          this.W9AlertPopupCall()
        } else {
          this.router.navigate(['/credentialing/locations/add']);
        }
      },
      error: (err) => {
      }
    })
  }

  isLocationAlreadyExists(selectedRecord: any) {
    const existingLocations = this.getStorageArray("locations");
    return existingLocations.some((loc: any) => loc.esLocationId === selectedRecord.esLocationId);
  }

  isSearchLocationAlreadyExists(location: any): boolean {
    const existingLocations = this.getStorageArray("locations");
    const incomingIds = [location?.locationId, location?.esLocationId].filter((id: any) => id != null);
    return existingLocations.some((loc: any) =>
      incomingIds.includes(loc?.locationId) || incomingIds.includes(loc?.esLocationId)
    );
  }

  // API groups tax entity, payees and locations per TIN; flatten them onto each location row.
  private buildLocationsFromResponse(res: any, tin: string, licenseState: any): any[] {
    const groups = Array.isArray(res) ? res : (res ? [res] : []);
    return groups.flatMap((group: any) => {
      const taxEntity = group?.taxEntityDetails ?? {};
      const payees = Array.isArray(group?.payees) ? group.payees : [];
      const groupLocations = Array.isArray(group?.locations)
        ? group.locations
        : (group?.locationId ? [group] : []);
      return groupLocations
        .filter((loc: any) => loc && loc.state == licenseState)
        .map((loc: any) => {
          const payee = this.matchPayeeForLocation(loc, payees);
          const dwVoicePhone = loc?.locationVoicePhone ?? loc?.voicePhone ?? null;
          const locationEmail = loc?.locationEmail ?? null;
          const dwEmail = locationEmail ?? payee?.payeeEmail ?? loc?.email ?? null;
          return {
            ...taxEntity,
            ...payee,
            ...loc,
            taxId: taxEntity?.taxId ?? tin,
            tin: taxEntity?.taxId ?? tin,
            name: loc?.locationName ?? loc?.name ?? '',
            locationEmail: locationEmail,
            voicePhone: dwVoicePhone,
            email: payee?.payeeEmail ?? loc?.email ?? null,
            dwVoicePhone: dwVoicePhone,
            dwEmail: dwEmail,
            taxTypeId: taxEntity?.taxIDTypeID ?? taxEntity?.taxTypeId ?? null,
            payeeId: payee?.payeeId ?? null,
            isTinFromDW: taxEntity?.isTinFromDW ?? true
          };
        });
    });
  }

  private getDistinctPayeesFromResponse(res: any): any[] {
    const groups = Array.isArray(res) ? res : (res ? [res] : []);
    const seenAddresses = new Set<string>();

    return groups.flatMap((group: any) => Array.isArray(group?.payees) ? group.payees : [])
      .filter((payee: any) => {
        const addressKey = [
          payee?.payeeAddress1,
          payee?.payeeAddress2,
          payee?.payeeCity,
          payee?.payeeState,
          payee?.payeeZip
        ].map((value: any) => `${value ?? ''}`.trim().toLowerCase()).join('|');

        if (seenAddresses.has(addressKey)) {
          return false;
        }
        seenAddresses.add(addressKey);
        return true;
      });
  }

  private getTaxEntityDetailsFromResponse(res: any, tin: string): any {
    const groups = Array.isArray(res) ? res : (res ? [res] : []);
    const normalizedTin = `${tin ?? ''}`.trim();
    const matchingGroup = groups.find((group: any) => {
      const taxEntity = group?.taxEntityDetails ?? {};
      const groupTin = `${taxEntity?.taxId ?? group?.taxId ?? group?.tin ?? ''}`.trim();
      return groupTin === normalizedTin;
    }) ?? groups[0];
    const taxEntity = matchingGroup?.taxEntityDetails ?? {};

    if (!matchingGroup || !Object.keys(taxEntity).length) {
      return {};
    }

    const resolvedTin = taxEntity?.taxId ?? matchingGroup?.taxId ?? matchingGroup?.tin ?? normalizedTin;
    return {
      ...taxEntity,
      taxId: resolvedTin,
      tin: resolvedTin,
      taxTypeId: taxEntity?.taxIDTypeID ?? taxEntity?.taxTypeId ?? null,
      isTinFromDW: taxEntity?.isTinFromDW ?? true
    };
  }

  private matchPayeeForLocation(location: any, payees: any[]): any {
    if (!payees.length) return {};
    const locationName = `${location?.locationName ?? location?.name ?? ''}`.trim().toLowerCase();
    const byName = payees.find((p: any) => `${p?.payeeName ?? ''}`.trim().toLowerCase() === locationName);
    if (byName) return byName;
    const byAddress = payees.find((p: any) =>
      `${p?.payeeAddress1 ?? ''}`.trim().toLowerCase() === `${location?.address1 ?? ''}`.trim().toLowerCase() &&
      `${p?.payeeZip ?? ''}`.trim() === `${location?.zip ?? ''}`.trim()
    );
    if (byAddress) return byAddress;
    return payees.length === 1 ? payees[0] : {};
  }

  private getSessionLocationsByTin(tin: any): any[] {
    if (!tin) return [];
    const existingLocations = this.getStorageArray("locations");
    return existingLocations
      .filter((loc: any) => loc?.tin == tin)
      .map((loc: any) => ({
        ...loc,
        locationId: loc?.esLocationId ?? loc?.locationId,
        name: loc?.name ?? loc?.locationName ?? '',
        address1: loc?.address1 ?? loc?.address ?? ''
      }));
  }

  private mergeLocations(apiLocations: any[], sessionLocations: any[]): any[] {
    const seenLocationIds = new Set<any>();
    return [...apiLocations, ...sessionLocations].filter((location: any) => {
      const locationId = location?.locationId ?? location?.esLocationId;
      if (locationId == null) {
        return true;
      }
      if (seenLocationIds.has(locationId)) {
        return false;
      }
      seenLocationIds.add(locationId);
      return true;
    });
  }

}
